export const getAccountPayload = (account, locationInfo, addressSuggestion = {}) => {
  const {
    BusinessAddress: {
      Line1,
      PostalCode,
      StateOrProvince,
      City,
    },
  } = account;

  const hasAddress = Line1 && PostalCode && StateOrProvince && City;

  let hasDelta = false;
  const updatedAccount = { ...account };
  let bizAddrInfo = { ...updatedAccount.BusinessAddress };

  if (hasAddress) {
    return {
      hasDelta,
      updatedAccount,
    };
  }

  if (addressSuggestion.countryRegionIso2) {
    hasDelta = true;

    bizAddrInfo = {
      ...bizAddrInfo,
      Country: addressSuggestion.countryRegionIso2,
    };
  }

  if (addressSuggestion.countryRegion) {
    hasDelta = true;

    bizAddrInfo = {
      ...bizAddrInfo,
      CountryName: addressSuggestion.countryRegion,
    };
  }

  if (addressSuggestion.locality) {
    hasDelta = true;

    bizAddrInfo = {
      ...bizAddrInfo,
      City: addressSuggestion.locality,
    };
  }

  if (addressSuggestion.addressLine || locationInfo) {
    hasDelta = true;

    bizAddrInfo = {
      ...bizAddrInfo,
      Line1: addressSuggestion.addressLine || locationInfo,
      Line2: null,
      Line3: null,
      Line4: null,
    };
  }

  if (addressSuggestion.postalCode) {
    hasDelta = true;

    bizAddrInfo = {
      ...bizAddrInfo,
      PostalCode: addressSuggestion.postalCode,
    };
  }

  if (addressSuggestion.adminDistrict) {
    hasDelta = true;

    bizAddrInfo = {
      ...bizAddrInfo,
      StateOrProvince: addressSuggestion.adminDistrict,
    };
  }

  return {
    hasDelta,
    updatedAccount: {
      ...updatedAccount,
      BusinessAddress: bizAddrInfo,
    },
  };
};

export const getCustomerPayload = (customer, phoneNumber) => {
  const { BusinessPhone } = customer;
  let hasDelta = false;
  let updatedCustomer = { ...customer };

  if (BusinessPhone) {
    return {
      hasDelta,
      updatedCustomer,
    };
  }

  if (phoneNumber) {
    hasDelta = true;

    updatedCustomer = {
      ...updatedCustomer,
      BusinessPhone: phoneNumber,
    };
  }

  return { hasDelta, updatedCustomer };
};
